import React from "react";
import AntdModal, { ModalProps, ModalFuncProps, ActionButtonProps } from "antd/lib/modal";
import { withError} from '@fishx/tracker';

const config = AntdModal.config;
const useModal = AntdModal.useModal;
const destroyAll = AntdModal.destroyAll;
const info = AntdModal.info;
const success = AntdModal.success;
const error = AntdModal.error;
const warn = AntdModal.warn;
const warning = AntdModal.warning;
const confirm = AntdModal.confirm;


interface IModalProps extends React.FC<ModalProps> {
  config: typeof config;
  useModal: typeof useModal;
  destroyAll: typeof destroyAll;
  info: typeof info;
  success: typeof success;
  error: typeof error;
  warn: typeof warn;
  warning: typeof warning;
  confirm: typeof confirm;


}
export const Modal: IModalProps = (props) => {
  const { children, ...other } = props;
  return (
        <AntdModal {...other}>{children}</AntdModal>
  );
}
Modal.config = config;
Modal.useModal = useModal;
Modal.destroyAll = destroyAll;
Modal.info = info;
Modal.success = success;
Modal.error = error;
Modal.warn = warn;
Modal.warning = warning;
Modal.confirm = confirm;

Modal.displayName = 'Modal';
export { ModalFuncProps, ActionButtonProps }
export default withError(Modal);



// WEBPACK FOOTER //
// ./src/components/modal/index.tsx